/*
 * $Description:
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2019年12月12日 11:06:34 +0800
 * @最后修改时间: 2022-04-01 16:25:16
 * @FilePath: \mrc-ess-fronted\src\api\request.js
 */
import _this from "@/main.js";
import { getDateTime } from "@/util/func";
import Vue from "vue";
export default function ajaxRequest(
  data,
  url,
  method,
  sign,
  global,
  type = null,
  notAlert = false,
  export_title = null
) {
  var requesturl = "";
  let timer = new Date().valueOf();
  let baseUrl = process.env.VUE_APP_BaseUrl;
  if (type == "lang" || type == "base" || type == "upload")
    baseUrl = process.env.VUE_APP_langBaseUrl; //国际化请求
  if (type == "client" || type == "client_export" || type == "client_import")
    baseUrl = process.env.VUE_APP_clientBaseUrl; //业务端请求
  if (url.indexOf("http") != -1) {
    requesturl = url;
  } else if (url.indexOf("/prompt/business/findPrompt") != -1) {
    //高級參照特殊
    requesturl = baseUrl.replace("/admin-web", "") + url;
  } else if (url.indexOf("/login/") != -1 || url.indexOf("/logout/") != -1) {
    //登录接口特殊
    requesturl = baseUrl.replace("/api/admin-web", "") + url;
  } else {
    requesturl = baseUrl + url;
  }
  // header
  let header = {};
  let json = JSON.parse(data["formData"]);
  // 添加将要放在请求头的参数名称
  let headerKey = [
    "system-client-type",
    "current-utc-time",
    "system-client-version",
    "client-type",
    "client-version-code",
    "device-type",
    "client-version-name",
    "system-language-code",
    "system-version",
    "theme-mode",
    "time-zone-offset",
    "token",
    "signature",
  ];
  for (let key in json) {
    if (headerKey.indexOf(key) != -1) {
      header[key] = json[key];
      delete json[key];
    }
    // 删除formdata里文件参数
    if (json["files"]) delete json["files"];
  }
  data["formData"] = JSON.stringify(json);
  let i = false;
  if (data["files"]) {
    i = true;
    let formData = new FormData();
    formData.append("files", data["files"]);
    formData.append("formData", data["formData"]);
    data = formData;
  }
  // 提示
  let confirm = null;
  return new Promise((resolve, reject) => {
    if (_this != undefined) {
      _this.$NProgress.remove();
    }
    // 自定义请求参数，为不同类型的请求动态添加参数
    let requestArgs = {
      data: data,
      dataType: type == "export" || type == "client_export" ? "" : "json",
      global: global, //局部禁用，此处控制是否显示loading，详情查看util/progress.js
      // contentType:"application/x-www-form-urlencoded; charset=utf-8",//默认
      type: method,
      crossDomain: true,
      timeout:
        180000 *
        (type == "import" ||
        type == "client_import" ||
        process.env.NODE_ENV == "lsj"
          ? 20
          : 1), //文件导入60分钟超时
      xhrFields: {
        responseType: type == "export" || type == "client_export" ? "blob" : "",
        //   withCredentials: true,
      }, //配置带cookie
      beforeSend: function (XMLHttpRequest) {
        XMLHttpRequest.setRequestHeader("signature", sign);
        for (let k in header) {
          XMLHttpRequest.setRequestHeader(k, header[k]);
        }
      },
      success: function (res, f, response) {
        if (
          res.code == "01703" ||
          res.code == "01700" ||
          res.code == "01500" ||
          res.code == "01704" ||
          res.code == "01708"
        ) {
          //未登录
          // 2021-03-19 notAlert 不需要弹出提示，直接到登陆界面
          if (_this != undefined && !notAlert) {
            confirm = _this.$confirm({
              text: res.msg,
              title: _this.$t("message_essweb_form_submit_errorTitle"),
              button: [
                {
                  text: _this.$t(
                    "message_essweb_system_tools_dialogCancelBtnLabel"
                  ),
                  show: false,
                  ontap: function () {
                    confirm.close();
                  },
                },
                {
                  text: _this.$t("label_essweb_form_tools_oKBtnLabel"),
                  show: true,
                  ontap: function () {
                    confirm.close();
                  },
                },
              ],
            });
            _this.$Sleep(1000).then(() => {
              // from: _this.$route.path
              _this.$toPage("/login", {}, "replace");
            });
          }
          if (notAlert) {
            _this.$Sleep(300).then(() => {
              // from: _this.$route.path
              _this.$toPage("/login", {}, "replace");
            });
          }
          reject(res);
        }
        if (res.code == 200) {
          // && res.status == "success"
          //发送日志.
          // _this.$logZ({ message: method + ":" + url, data: data });
          resolve(res);
        } else if (res.code == 600) {
          // 文件上传专属
          resolve(res);
        } else if (
          res.code == "1100076" ||
          res.code == "1000029" ||
          res.code == "1000067"
        ) {
          //报销超支提示，请假超支提示
          reject(res);
        } else if (type == "export" || type == "client_export") {
          // 文件导出 start
          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }); //, {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}//, {type:'application/vnd.ms-excel;charset=utf-8'}
          const blobUrl = window.URL.createObjectURL(blob);

          let xxx = ""; //后缀
          switch (res.type) {
            case "application/vnd.ms-excel":
              xxx = ".xls";
              break;
            // Safari
            case "application/vnd.ms-excel;charset=utf-8":
              xxx = ".xls";
              break;
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
              xxx = ".xlsx";
              break;
            // Safari
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8":
              xxx = ".xlsx";
              break;
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
              xxx = ".docx";
              break;
            // Safari
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8":
              xxx = ".docx";
              break;
            case "application/msword":
              xxx = ".doc";
              break;
            // Safari
            case "application/msword;charset=utf-8":
              xxx = ".doc";
              break;
            case "application/vnd.ms-powerpoint":
              xxx = ".ppt";
              break;
            // Safari
            case "application/vnd.ms-powerpoint;charset=utf-8":
              xxx = ".ppt";
              break;
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
              xxx = ".pptx";
              break;
            // Safari
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation;charset=utf-8":
              xxx = ".pptx";
              break;
            default:
              xxx = ".text";
              break;
          }
          const a = document.createElement("a");
          a.style.display = "none";
          // blobUrl.substring(blobUrl.lastIndexOf('/'),blobUrl.length).replace('_','')
          a.download =
            export_title +
            getDateTime(new Date().valueOf(), "YYYY_MM_DD_HH_mm_ss") +
            xxx;
          a.href = blobUrl;
          a.click();
          // 文件导出 end
        } else {
          // 错误提示
          if (_this != undefined && !notAlert)
            confirm = _this.$confirm({
              text: res.msg,
              title: _this.$t("message_essweb_form_submit_errorTitle"),
              button: [
                {
                  text: _this.$t(
                    "message_essweb_system_tools_dialogCancelBtnLabel"
                  ),
                  show: false,
                  ontap: function () {
                    confirm.close();
                  },
                },
                {
                  text: _this.$t("label_essweb_form_tools_oKBtnLabel"),
                  show: true,
                  ontap: function () {
                    confirm.close();
                  },
                },
              ],
            });
          reject(res);
        }
      },
      complete: function (res) {
        Vue.prototype.$Api = Vue.prototype.$Api.filter(
          (ele) => ele.timer !== timer
        );
      },
      error: function (err) {
        //发送错误日志，使用logZ
        // _this.$logZ({ message: method + "" + requesturl, err: err });
        if (err.statusText === "abort") {
          //取消请求
          return;
        }
        if (_this != undefined && !notAlert) {
          // 错误提示
          confirm = _this.$confirm({
            text: err.statusText,
            title: _this.$t("message_essweb_form_submit_errorTitle"),
            button: [
              {
                text: _this.$t(
                  "message_essweb_system_tools_dialogCancelBtnLabel"
                ),
                show: false,
                ontap: function () {
                  confirm.close();
                },
              },
              {
                text: _this.$t("label_essweb_form_tools_oKBtnLabel"),
                show: true,
                ontap: function () {
                  confirm.close();
                },
              },
            ],
          });
          // _this.$toPage("/net_error", null, "replace");
          _this.$store.dispatch("updateSystemStatus", 1);
        }
        reject(err);
      },
    };
    // 特殊处理上传文件请求
    if (i) {
      requestArgs["contentType"] = false;
      requestArgs["processData"] = false;
    } else {
      requestArgs["contentType"] =
        "application/x-www-form-urlencoded; charset=utf-8";
    }
    // 开始请求
    let api = $.ajax(requesturl, requestArgs);
    // 用以控制全局请求
    //排除其他api，咧如导出导入，label,global
    if (type === null || type === "client" || type === "admin")
      if (!notAlert) Vue.prototype.$Api.push({ timer, api });
  });
}
